@if (activeField) {
  <div class="absolute right-0 top-full z-50 mt-1 bg-white border border-stone-200 rounded-lg shadow-xl p-3"
       style="width: calc(200% + 2.5rem); max-width: calc(100vw - 1rem)">
    <div class="space-y-1.5">
      @for (row of arabicKeyboardLayout; track $index) {
        <div class="flex flex-nowrap gap-1 w-full" dir="rtl">
          @if ($index === 0) {
            <button type="button" (mousedown)="$event.preventDefault()" (click)="removeLastCharacter()"
              class="flex-none w-10 h-9 bg-stone-200 hover:bg-stone-300 text-stone-800 font-bold text-sm rounded-lg transition-colors flex items-center justify-center border border-stone-300">
              ⌫
            </button>
          }
          @for (char of row; track char) {
            <button type="button" (mousedown)="$event.preventDefault()" (click)="addCharacter(char)"
              class="flex-1 min-w-0 h-9 bg-white border border-stone-200 hover:bg-stone-50 hover:border-primary-300 text-stone-800 font-semibold text-sm rounded-lg transition-colors flex items-center justify-center">
              {{ char }}
            </button>
          }
        </div>
      }
      <div class="flex gap-2 mt-1">
        <button type="button" (mousedown)="$event.preventDefault()" (click)="addCharacter(' ')"
          class="flex-1 py-1.5 bg-white border border-stone-200 hover:bg-stone-50 text-stone-600 font-medium rounded-lg transition-colors text-sm">
          مسافة
        </button>
        <button type="button" (mousedown)="$event.preventDefault()" (click)="close()"
          class="px-6 py-1.5 bg-primary-600 hover:bg-primary-700 text-white font-medium rounded-lg transition-colors text-sm">
          إغلاق
        </button>
      </div>
    </div>
  </div>
}
